import React, {Component} from 'react';
import PropTypes from "prop-types";
import exporter from "./SvgToPng";

export class ExportAsImage extends Component {

  static propTypes = {
    querySelector: PropTypes.string.isRequired,
    name: PropTypes.string,
    className: PropTypes.string
  };

  static defaultProps = {
    name: "download",
    className: ""
  };

  render() {

    return (
      <button className={`btn btn-outline-secondary ${this.props.className}`} onClick={() => {
        return exporter(this.props.querySelector, this.props.name)
      }}>
        <i className="fas fa-cloud-download fa-spacer-right"/>
      </button>
    )
  }

}
